import $ from "jquery";
export default function flipBox() {

        function updateFlipBoxHeights() {
            let maxHeight = 0;

            $('.flip-box').css('height', '');
            $('.flip-box .front, .flip-box .back').css('height', '');

            $('.flip-box').each(function() {
                let frontHeight = $(this).find('.front').outerHeight(true);
                let backHeight = $(this).find('.back').outerHeight(true);
                let thisHeight = Math.max(frontHeight, backHeight);
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $('.flip-box').height(maxHeight);
            $('.flip-box .front, .flip-box .back').css('height', '100%');
        }

        updateFlipBoxHeights();
        $(window).resize(debounce(updateFlipBoxHeights, 250));


        $('.flip-box').on('mouseover', function() {
            $('.flip-box').not(this).removeClass('flipped');
            $(this).addClass('flipped');
        });

        function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this, args = arguments;
            let later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

}